exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".banner-header[data-v-7c85e319]{display:flex;align-items:center;justify-content:space-between;height:36px;background-color:#eee;font-size:16px;padding:8px 30px;margin:20px 0}.table-wrapper[data-v-7c85e319]{padding:12px}.img-wrap[data-v-7c85e319]{display:flex;align-items:center;justify-content:center;padding:18px 0}.img-wrap img[data-v-7c85e319]{width:160px;height:90px;object-fit:cover}.pagination[data-v-7c85e319]{text-align:right;margin-bottom:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7c85e319&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/banner/bannerManage.vue
// module id = 590
// module chunks = 0